import { ApolloError } from '@apollo/client';
import { showToast } from './showToast';
import { remapApolloErrors } from './remapApolloErrors';

export const triggerErrorToast =
  (summary: string): ((error: ApolloError | unknown) => void) =>
  (error: ApolloError | unknown): void =>
    showToast({
      severity: 'error',
      summary,
      detail: remapApolloErrors(error as ApolloError)
    });
